// redux/actions/notificationActions.js
import axios from '../../utils/axiosConfig';

export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';

export const setNotifications = (notifications) => ({
  type: SET_NOTIFICATIONS,
  payload: notifications,
});

export const fetchNotifications = (userId) => async (dispatch) => {
  if (!userId) return;
  try {
    const { data } = await axios.get(`/api/notifications/${userId}`);
    dispatch(setNotifications(data));
  } catch (error) {
    console.error('Error fetching notifications:', error);
  }
};